import { CallbackObject } from 'api/core/get-page-function';
import { instance } from 'api/core';

export const createCircuit = async (
    warehouseId: string,
    name: string,
    priority: number,
    callback: CallbackObject<void>
) => {
    const config = {
        headers: {
            'Content-Type': 'application/json',
        },
    };

    const body = {
        warehouseId,
        name,
        priority
    };

    try {
        await instance.post('/picking/circuits', body, config);
        callback.success();
    } catch (err) {
        if (callback.error) callback.error(err);
    }
};
